import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const avatars = [
  { bg: "bg-primary/80", initial: "S" },
  { bg: "bg-violet-500/80", initial: "N" },
  { bg: "bg-emerald-500/80", initial: "P" },
  { bg: "bg-amber-500/80", initial: "K" },
];

export default function HeroSection() {
  const scrollToFeatures = () => {
    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="flex flex-col items-center justify-center px-4 pt-28 pb-20 text-center md:pt-36 md:pb-28 max-w-5xl mx-auto">
      {/* AI Badge */}
      <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-violet-500/10 text-violet-400 mb-7">
        <Sparkles className="h-3 w-3" />
        AI-native platform
      </span>

      {/* Headline */}
      <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-foreground leading-[1.05]">
        Your marketing{" "}
        <span className="text-primary">runs itself.</span>
      </h1>

      {/* Subtitle */}
      <p className="mt-6 max-w-xl text-lg sm:text-xl text-muted-foreground mx-auto leading-relaxed">
        AI scores your leads, preps your meetings, and alerts you before clients churn. You focus on closing deals.
      </p>


      {/* CTA Buttons — primary stands out via size, shadow, glow */}
      <div className="mt-10 flex w-full flex-col-reverse gap-3 sm:w-auto sm:flex-row sm:items-center justify-center">
        <Button
          variant="ghost"
          size="lg"
          className="w-full sm:w-auto rounded-xl px-6 text-muted-foreground hover:text-foreground"
          onClick={scrollToFeatures}
        >
          See how it works
        </Button>
        <Button
          asChild
          size="lg"
          className="w-full sm:w-auto rounded-xl px-8 h-12 text-base font-semibold shadow-lg shadow-primary/30 hover:shadow-primary/40 hover:scale-[1.02] transition-all"
        >
          <Link to="/signup">Start free — no credit card</Link>
        </Button>
      </div>

      {/* Social Proof */}
      <div className="flex items-center justify-center gap-3 mt-6">
        <div className="flex -space-x-2">
          {avatars.map((a) => (
            <div
              key={a.initial}
              className={`w-7 h-7 rounded-full border-2 border-background ${a.bg} flex items-center justify-center text-[10px] font-medium text-white`}
            >
              {a.initial}
            </div>
          ))}
        </div>
        <span className="text-xs text-muted-foreground">Join 100+ Thai SMEs · 2 min setup</span>
      </div>
    </section>
  );
}
